import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=03b5a01c&"
import script from "./input-date-component.ts?vue&type=script&lang=ts&"
export * from "./input-date-component.ts?vue&type=script&lang=ts&"
import style0 from "./input-date.vue?vue&type=style&index=0&id=03b5a01c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports